import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DropDownComponent } from './dropDown.component';

@NgModule({
	imports: [
		RouterModule.forChild([
			{
				path:'',
				component: DropDownComponent
			}
		])
	],
	exports: [
		RouterModule
	]
})
export class DropRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/view/dropDown/drop-routing.module.ts